const Validations = {
    required : ( element ) => {
        return element.type=== 'checkbox' ? element.checked : element.value.trim() !== '';
    },
    email : ( element ) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test( String( element.value ).toLowerCase() );
    }
};

const ValidationMessages = typeof window.ValidationMessages  !== "undefined" ? window.ValidationMessages : {
    'required'  : 'The field is required',
    'email'     : 'Email is not valid',
};

export { Validations, ValidationMessages };
